import template from './sw-dashboard-index.html.twig';
import './sw-dashboard-index.scss';

export default Shopware.Component.wrapComponentConfig({
    template,
});
